import api from '../../../services/api';

export const categoryService = {
  // Groups
  listGroups: () => api.get('/groups'),
  createGroup: (name: string) => api.post('/groups', { name }),
  updateGroup: (id: string, data: { name?: string }) => api.put(`/groups/${id}`, data),
  deleteGroup: (id: string) => api.delete(`/groups/${id}`),
  updateGroupVisibility: (id: string, field: string, value: boolean) =>
    api.patch(`/groups/${id}/visibility`, { field, value }),

  // Classifiers
  listClassifiers: (groupId?: string) =>
    api.get('/classifiers', { params: groupId ? { groupId } : {} }),
  createClassifier: (groupId: string, name: string) =>
    api.post('/classifiers', { groupId, name }),
  updateClassifier: (id: string, data: { name?: string; description?: string; groupId?: string }) =>
    api.put(`/classifiers/${id}`, data),
  deleteClassifier: (id: string) => api.delete(`/classifiers/${id}`),
  updateClassifierVisibility: (id: string, field: string, value: boolean) =>
    api.patch(`/classifiers/${id}/visibility`, { field, value }),

  // Descriptors (transactions grouped by description)
  getDescriptionCategories: () => api.get('/transactions/description-categories'),
  batchUpdateByDescription: (descriptions: string[], fields: Record<string, string>) =>
    api.patch('/transactions/batch-by-description', { descriptions, fields }),
};
